import React from 'react';
import DetailedRow from 'components/DetailsComponents/DetailedRow';

export default function LeavelistGeneralDetails({ generalDetailsData }) {
  return generalDetailsData.map(({ label, value }, index) => (
    <DetailedRow key={index} label={label} value={value} disableFlex />
  ));
}
